var map = {
	"./wb_finde-blumen.mp3": 6131,
	"./wb_finde-fahrrad.mp3": 2395,
	"./wb_finde-katzen.mp3": 7854,
	"./wb_finde-muell.mp3": 6576,
	"./wb_finde-roller.mp3": 7031,
	"./wb_finde-voegel.mp3": 6504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2288;